import { render, staticRenderFns } from "./UpTriangleSvg.vue?vue&type=template&id=18dbd259"
import script from "./UpTriangleSvg.vue?vue&type=script&lang=js"
export * from "./UpTriangleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports